import {cloneDeep} from 'lodash';

import {ctrlStages, ctrlEntityTypes} from '../const';
import {IEntity} from './ChangesStore';
import {EntityType, ISerializable, OperationType} from '../types';

const invertedOperations = {
  [ctrlStages.ADD]: ctrlStages.DELETE,
  [ctrlStages.DELETE]: ctrlStages.ADD,
  [ctrlStages.CHANGE]: ctrlStages.CHANGE
};

class Step {
  _operation: OperationType;
  item?: IEntity;
  previousState?: IEntity;
  id?: string;
  type?: EntityType;

  get isCreate(): boolean {
    return this._operation === ctrlStages.ADD;
  }

  get isUpdate(): boolean {
    return this._operation === ctrlStages.CHANGE;
  }

  get isDelete(): boolean {
    return this._operation === ctrlStages.DELETE;
  }

  get isNode(): boolean {
    return this.type === ctrlEntityTypes.NODE;
  }

  get isLink(): boolean {
    return this.type === ctrlEntityTypes.LINK;
  }

  get isAggregateLink(): boolean {
    return this.type === ctrlEntityTypes.AGGREGATE;
  }

  get isLinksGroup(): boolean {
    return this.type === ctrlEntityTypes.LINKS_GROUP;
  }

  constructor(operation: OperationType, item?: ISerializable, previousState?: ISerializable) {
    [this._operation, this.item, this.previousState, this.type, this.id] = [
      operation,
      item?.serialize(),
      previousState?.serialize(),
      item?.type ?? previousState?.type,
      item?.id ?? previousState?.id
    ];
  }

  setResult(item: ISerializable) {
    this.item = item?.serialize();
  }

  clone(): Step {
    const result = new Step(this._operation);
    Object.assign(result, {
      item: cloneDeep(this.item), previousState: cloneDeep(this.previousState), type: this.type, id: this.id
    });
    return result;
  }

  get inverted(): Step {
    const step = new Step(invertedOperations[this._operation]);
    [step.previousState, step.item, step.type, step.id] = [
      this.isUpdate ? this.item : this.previousState,
      this.isUpdate ? this.previousState : this.item,
      this.type,
      this.id
    ];
    return step;
  }

  static creation(item: ISerializable): Step {
    return new Step(ctrlStages.ADD, item);
  }

  static deletion(item: ISerializable): Step {
    return new Step(ctrlStages.DELETE, item);
  }

  static modification(item: ISerializable, previousState?: ISerializable): Step {
    return new Step(ctrlStages.CHANGE, item, previousState);
  }
}

export default Step;
